import { Dropdown } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { text_truncate, YYYYMMDDToDate } from '../../../../../helpers';
import { SeasonWeekSelectorPropsType } from '../types';
import { DEFAULT_WEEK_COMPARE_TO_DATA } from '../../../../../config/constants';

const SeasonWeekSelector = ({ newData, setNewData, changeViewMonths, weeksData }: SeasonWeekSelectorPropsType) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setNewData({
      ...newData,
      week: DEFAULT_WEEK_COMPARE_TO_DATA
    });
  }, [newData.year]);
  const seasonWeekList: JSX.Element[] = [];
  weeksData.forEach((week, index) => {
    seasonWeekList.push(
      <li
        key={week.weekName + index} onClick={() => {
        changeViewMonths(YYYYMMDDToDate(week.startOfWeek));
        setNewData({
          ...newData,
          selectedDates: [{ start: YYYYMMDDToDate(week.startOfWeek), end: YYYYMMDDToDate(week.endOfWeek) }],
          week: week,
          default: 'custom'
        });
        setShow(false);
      }}
      >
        <div><label htmlFor={'styled-checkbox-' + index} className="check-l">{week.weekName}</label></div>
      </li>
    );
  });
  return (
    <>
      <label>Jump to Season Week</label>
      <Dropdown
        className={`a-week${weeksData.length === 0 ? ' disabled-week-selector' : ''}`}
        show={show}
        onToggle={show ? () => setShow(false) : () => setShow(weeksData.length > 0)}
      >
        <Dropdown.Toggle
          id="dropdown-basic"
          className={`label-season-week-selector${newData.week.week !== -1 ? '-selected' : ''}`}
        >
          <label className={`label-label`}>
            {text_truncate(newData.week.weekName, 13, '...')}
          </label>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="p-001">
            <div className="p-b-03" style={{ padding: '0' }}>
              <ul>
                {seasonWeekList}
              </ul>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SeasonWeekSelector;